// siteCatalyst.js now load Analytics Engine


if(!window.ae_loaded){
  
  // Temporary shell for old-style GA tracking.
  function noop(){}
  var pageTracker = pageTracker || { _trackPageview: noop, _trackEvent: noop, _setAccount: noop }, AE = AE || [];

  // Temporary callback for compatibility with AE async.
  function setSiteCatalystVariable(c){
    AE.push([ 'setTracker', c ]);
  }

  (function(d, s){ // Analytics Engine
    var x = d.createElement(s), f = d.getElementsByTagName(s)[0]; 
    x.type = 'text/javascript'; x.async = true;
    x.src = '//dpp750yjcl65g.cloudfront.net/m/princess/ae.js';
    x.className = 'siteCatalyst-loaded';
    f.parentNode.insertBefore(x, f);  
  })(document, 'script');

  window.ae_loaded = true;
}





(function(window, document){
 
  // Asynchronous javascript loader
  function _ld(url){
    var x = 'script', s = document.getElementsByTagName(x)[0], q = document.createElement(x);
    q.async = true; q.src = url; q.type = 'text/javascript';
    return s.parentNode.insertBefore(q, s);
  }

  // Load global utilities
  _ld('/assetroot/js/global/util.js');

})(window, document);


